import { Box, Button, Card, CardContent, Checkbox, Chip, Stack, Typography, useTheme } from "@mui/material";
import VerifiedIcon from '@mui/icons-material/Verified';

interface MobileUserCardProps {
    user: {
        id: number;
        firstName: string;
        lastName: string;
        createdDate: string;
        isVerified: boolean;
    };
    index: number;
    selectedUsers: number[];
    handleSelectUser: (id: number) => void;
    handleVerifyUser: (id: number) => void;
}

const MobileUserCard: React.FC<MobileUserCardProps> = ({
    user,
    index,
    selectedUsers,
    handleSelectUser,
    handleVerifyUser
}) => {
    const theme = useTheme();

    return (
        <Card
            elevation={1}
            sx={{
                mb: 2,
                border: selectedUsers.includes(user.id) ? `2px solid ${theme.palette.primary.main}` : 'none',
                transition: 'all 0.2s ease-in-out'
            }}
        >
            <CardContent sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Checkbox
                            checked={selectedUsers.includes(user.id)}
                            onChange={() => handleSelectUser(user.id)}
                            size="small"
                        />
                        <Typography variant="body2" color="text.secondary">
                            #{index + 1}
                        </Typography>
                    </Box>
                    <Chip
                        label={user.isVerified ? 'Verified' : 'Pending'}
                        color={user.isVerified ? 'success' : 'warning'}
                        size="small"
                        icon={user.isVerified ? <VerifiedIcon /> : undefined}
                    />
                </Box>

                <Stack spacing={1} mb={2}>
                    <Typography variant="h6" fontWeight="bold">
                        {user.firstName} {user.lastName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Created: {new Date(user.createdDate).toLocaleDateString()}
                    </Typography>
                </Stack>

                <Button
                    variant={user.isVerified ? "outlined" : "contained"}
                    color="primary"
                    size="small"
                    onClick={() => handleVerifyUser(user.id)}
                    disabled={user.isVerified}
                    startIcon={<VerifiedIcon />}
                    fullWidth
                >
                    {user.isVerified ? 'Verified' : 'Verify User'}
                </Button>
            </CardContent>
        </Card>
    );
};


export default MobileUserCard;